import React, { useContext, useState } from 'react';
import type { PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';

import { alpha, colors, scale } from './themeCore';
import { defaultDark, defaultLight } from './themeDefault';

declare module 'styled-components' {
    export interface DefaultTheme extends Theme {}
}

const themeCommons = {
    colors: { ...colors },
    alpha: { ...alpha },
    scale: { ...scale },
};

export const themeDefault: Theme = {
    ...themeCommons,
    ...defaultLight,
};

export const themes: { [key: string]: { light: Theme; dark: Theme } } = {
    default: {
        light: { ...themeCommons, ...defaultLight },
        dark: { ...themeCommons, ...defaultDark },
    },
};
interface ContextProps {
    light: Theme;
    dark: Theme;
    updateTheme: (themeName: string) => void;
}

const initial: ContextProps = {
    ...themes.default,
    updateTheme: () => {},
};

interface ThemeProps {
    theme?: 'default';
}

export const ThemeContext = React.createContext<ContextProps>({ ...initial });

export const ThemeController = ({ theme = 'default', children }: PropsWithChildren<ThemeProps>) => {
    const [currentTheme, setTheme] = useState(theme);
    return (
        <ThemeContext.Provider
            value={{
                ...themes[currentTheme],
                updateTheme: (themeName: string) => {
                    if (themes[themeName]) {
                        setTheme('default');
                    }
                },
            }}
        >
            {children}
        </ThemeContext.Provider>
    );
};

export const DarkContainer = ({ children }: PropsWithChildren) => {
    const theme = useContext(ThemeContext);
    return <ThemeProvider theme={theme.dark}>{children}</ThemeProvider>;
};
